import React, {memo, useState} from 'react';
import {ChartOptions} from "chart.js";
import {Doughnut} from "react-chartjs-2";

const DoughnutChart = memo(({value, description}: { value: number, description?: string }) => {
  const [displayPerformanceExplanation, setDisplayPerformanceExplanation] = useState<boolean>(false);

  const donutData = {
    datasets: [
      {
        data: [value, 100 - value],
        backgroundColor: ["#059669", "#E5E7EB"],
        borderWidth: 0,
      },
    ],
  };

  const donutOptions: ChartOptions<any> = {
    cutout: "80%",
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false
      }
    },
  };

  return (
    <div
      className="relative"
      onMouseOver={() => setDisplayPerformanceExplanation(true)}
      onMouseOut={() => setDisplayPerformanceExplanation(false)}
    >
      <div className="bg-white rounded-xl shadow flex items-center justify-center hover:shadow-md">
        <div className="relative min-h-[129px] w-24 h-24">
          <Doughnut data={donutData} options={donutOptions}/>
          <span className="absolute inset-0 text-emerald-600 flex items-center justify-center font-bold text-lg">
          {value || 0} %
        </span>
        </div>
      </div>
      {(displayPerformanceExplanation && description) && (
        <div className="absolute left-0 mt-1 bg-white p-3 rounded-xl border border-white/1 min-w-[225px] shadow-lg z-20">
          <p className="text-xs text-gray-500">
            {description}
          </p>
        </div>
      )}
    </div>
  );
});

export default DoughnutChart;